module.exports = "query Rescues ($page: Int = 1, $limit: Int = 10, $search: String, $event: String, $start_date: String, $end_date: String) {\n  rescues (page: $page, limit: $limit, search: $search, event: $event, start_date: $start_date, end_date: $end_date) {\n    data {\n      user {\n        id\n        name\n        email\n      }\n      company {\n        id\n        name\n      }\n      campaign {\n        id\n        name\n      }\n      partner {\n        name\n      }\n      event\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Rescues.graphql
// module id = daRr
// module chunks = 1624